module.exports = __webpack_public_path__ + "static/media/id-card-1.291d09fb.svg";